import { useState } from 'react';

export default function PromoDetails() {
  const [selectedChallenge, setSelectedChallenge] = useState('50k');

  const challenges = {
    '10k': { original: 199, discounted: 90, savings: 109 },
    '25k': { original: 299, discounted: 135, savings: 164 },
    '50k': { original: 499, discounted: 225, savings: 274 },
    '100k': { original: 899, discounted: 405, savings: 494 },
    '200k': { original: 1599, discounted: 720, savings: 879 }
  };

  const currentChallenge = challenges[selectedChallenge as keyof typeof challenges];

  return (
    <section className="py-24 bg-gradient-to-br from-[#0A1628] via-[#0D1B3A] to-[#1a0b2e] relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-cyan-500 rounded-full filter blur-[150px]"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-purple-600 rounded-full filter blur-[150px]"></div>
      </div>

      <div className="max-w-6xl mx-auto px-6 relative z-10">
        {/* Main Card */}
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
          {/* Top Banner */}
          <div className="h-2 bg-gradient-to-r from-cyan-500 via-blue-500 to-purple-600"></div>

          <div className="p-12">
            <h2 className="text-5xl font-black text-gray-900 mb-12 text-center">
              Your Exclusive <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-500 to-blue-600">RAMESCO</span> Advantage
            </h2>

            <div className="grid lg:grid-cols-2 gap-12">
              {/* Left Column - Discount Breakdown */}
              <div className="space-y-8">
                <div>
                  <p className="text-8xl font-black text-transparent bg-clip-text bg-gradient-to-r from-cyan-500 to-blue-600 leading-none">
                    55%
                  </p>
                  <p className="text-xl font-bold text-gray-700 uppercase tracking-wider mt-2">
                    OFF ALL CHALLENGES
                  </p>
                </div>

                <div className="space-y-4">
                  {[
                    'Instant account activation',
                    'All challenge types included',
                    'Lifetime discount validity',
                    'No hidden fees or charges',
                    'Full platform access',
                    'Priority customer support'
                  ].map((benefit, index) => (
                    <div key={index} className="flex items-start gap-3">
                      <div className="w-6 h-6 bg-cyan-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-check-line text-white text-sm"></i>
                      </div>
                      <p className="text-lg text-gray-700">{benefit}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Right Column - Savings Calculator */}
              <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl p-8 border border-gray-200">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">Calculate Your Savings</h3>

                {/* Challenge Selector */}
                <div className="mb-6">
                  <label className="block text-sm font-semibold text-gray-700 mb-3">
                    Select Challenge Size
                  </label>
                  <select
                    value={selectedChallenge}
                    onChange={(e) => setSelectedChallenge(e.target.value)}
                    className="w-full px-4 py-3 bg-white border-2 border-gray-300 rounded-xl text-gray-900 font-semibold focus:border-cyan-500 focus:outline-none transition-colors cursor-pointer"
                  >
                    <option value="10k">$10,000 Challenge</option>
                    <option value="25k">$25,000 Challenge</option>
                    <option value="50k">$50,000 Challenge</option>
                    <option value="100k">$100,000 Challenge</option>
                    <option value="200k">$200,000 Challenge</option>
                  </select>
                </div>

                {/* Price Display */}
                <div className="space-y-4 mb-6">
                  <div className="flex items-center justify-between">
                    <span className="text-gray-600">Original Price:</span>
                    <span className="text-2xl font-bold text-gray-400 line-through">
                      ${currentChallenge.original}
                    </span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-gray-600">With RAMESCO:</span>
                    <span className="text-4xl font-black text-green-600">
                      ${currentChallenge.discounted}
                    </span>
                  </div>
                  <div className="pt-4 border-t-2 border-gray-300">
                    <p className="text-center text-xl font-bold text-cyan-600">
                      You Save: ${currentChallenge.savings}
                    </p>
                  </div>
                </div>

                {/* CTA Button */}
                <a
                  href="https://qtfunded.quanttekel.com/ref/5428/?campaign=ramesco"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full px-6 py-4 bg-gradient-to-r from-cyan-500 to-blue-600 text-white text-lg font-bold rounded-xl hover:shadow-lg hover:shadow-cyan-500/50 transition-all duration-300 text-center whitespace-nowrap cursor-pointer"
                >
                  Activate Discount Code
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
